var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeCommissioned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 8.83366H3.125V10.917H14.5833V8.83366ZM14.5833 4.66699H3.125V6.75033H14.5833V4.66699ZM3.125 15.0837H10.4167V13.0003H3.125V15.0837ZM15.0104 21.3337L17.7083 18.6357L20.4062 21.3337L21.875 19.8649L19.1771 17.167L21.875 14.4691L20.4062 13.0003L17.7083 15.6982L15.0104 13.0003L13.5417 14.4691L16.2396 17.167L13.5417 19.8649L15.0104 21.3337Z",
    fill: "#d41121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeCommissioned);
export default __webpack_public_path__ + "static/media/DeCommissioned.957e3bed4067836bb62bb2824e04b40e.svg";
export { ForwardRef as ReactComponent };